let arrList = [
    {
        name: '金币*3000',
        prize_img: require('../assets/images/g01.png'),
        prize_id: '9',
        order: 1
    },
    {
        name: '金币*20000',
        prize_img: require('../assets/images/g02.png'),
        prize_id: '7',
        order: 2
    },
    {
        name: '复活币*2',
        prize_img: require('../assets/images/g03.png'),
        prize_id: '4',
        order: 3
    },
    {
        name: '金币*8000',
        prize_img: require('../assets/images/g04.png'),
        prize_id: '8',
        order: 4
    },
    {
        name: '钻石*300',
        prize_img: require('../assets/images/r002.png'),
        prize_id: '12',
        order: 5
    },
    {
        name: '绿色配件箱*1',
        prize_img: require('../assets/images/g05.png'),
        prize_id: '1',
        order: 6
    },
    {
        name: '巡逻卷*2',
        prize_img: require('../assets/images/g06.png'),
        prize_id: '6',
        order: 7
    },
    {
        name: '绿色腰带*1',
        prize_img: require('../assets/images/g07.png'),
        prize_id: '2',
        order: 8
    },
    {
        name: '头像框',
        prize_img: require('../assets/images/r003.jpg'),
        prize_id: '11',
        order: 9
    },
    {
        name: '蓝色钥匙*2',
        prize_img: require('../assets/images/g08.png'),
        prize_id: '5',
        order: 10
    },
    {
        name: '紫色钥匙*1',
        prize_img: require('../assets/images/r001.png'),
        prize_id: '10',
        order: 11
    },
    {
        name: '构造图纸*20',
        prize_img: require('../assets/images/g09.png'),
        prize_id: '3',
        order: 12
    },
]

export default arrList


// WEBPACK FOOTER //
// ./src/data/prize.js